export class IBaseInstance {
  constructor() {
    this.id = null;
    this.pending_tasks = [];
    this.attachment_disabled = 0;
    this.attachment = null;
    this.comments = null;
  }
}
